import i18n from "../../../../constants/i18n";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Date from "../../../../core/et3-input/et3-date";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getRootStore from "../../../../stores/core/root-store";
import React from "react";
import ET3Div from "../../../../core/et3-div";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";
import getAuditorsEventsStore from "../../../../stores/auditor-store/auditors-events-store";

const AuditorsEventsForm = withLiteObserverAndTheme((props) => {
  const allAdmins = getRootStore().allAdmins.get();
  const isGetButtonEnabled = getAuditorsEventsStore().isGetButtonEnabled.get();
  const { theme } = props;
  const { colors } = theme;

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("AUDITOR")}
          options={allAdmins}
          value={getAuditorsEventsStore().auditorInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getAuditorsEventsStore().setAuditorInput({
              auditor: value
            });
          }}
          onEnter={() => {}}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MIN")}
          dateInputObservable={getAuditorsEventsStore().dateMinInput}
          isEnabled={true}
        />
        <Et3Margin top={0} bottom={0} right={0} left={30} />
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MAX")}
          dateInputObservable={getAuditorsEventsStore().dateMaxInput}
          isEnabled={true}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={45}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Button
          onClick={() => getAuditorsEventsStore().getAuditorEventsData()}
          isEnabled={isGetButtonEnabled}
          size="LARGE"
          type="GET"
          text="GET"
        />
      </ET3Div>
    </React.Fragment>
  );
});
export default AuditorsEventsForm;
